<template>
    <div class="table-form-box">
        <div class="table-box">
            <div class="tabe-item">
                <div class="line-box">
                    <div class="line-title">{{ tableHeaderName }}</div>
                    <div class="line"></div>
                </div>
            </div>
            <div class="tabe-item">是否跟进</div>
            <div class="tabe-item">疗效评价</div>
        </div>
        <div class="table-box" v-for="(item, index) in list" :key="index"
            :class="item.trackStatus === 0 ? 'table-box-disable' : ''">
            <div class="tabe-item">
                <TextOverTooltip :content="item.name || '-'" />
            </div>
            <div class="tabe-item van-ellipsis">
                <template v-if="!isEdit">{{
                    findName(item.trackStatus, 1) || "无"
                }}</template>
                <div class="switch-box" v-else>
                    <van-switch v-model="item.trackStatus" size="20px" active-color="#4991FC" :active-value="1"
                        :inactive-value="0" inactive-color="#C5C5C5" />
                    <div class="switch-title" :class="!!item.trackStatus ? 'switch-title-active' : ''">
                        {{ !!item.trackStatus ? "是" : "否" }}
                    </div>
                </div>
            </div>
            <div class="tabe-item">
                <template v-if="!isEdit">
                    <TextOverTooltip :content="findName(item.effectFlag, 2) || '-'" />
                </template>
                <template v-else>
                    <vSelect :key="item.id" :options="selectList" :reduce="(item) => item.key" label="value"
                        :clearable="false" placeholder="请选择" v-model="item.effectFlag">
                        <template #open-indicator="{ attributes }">
                            <span v-bind="attributes">
                                <van-icon name="play" class="icon-box" />
                            </span>
                        </template>
                        <template #no-options>无匹配数据</template>
                    </vSelect>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import TextOverTooltip from '@/components/overTooltip/index.vue'
export default {
    name: "TableForm",
    props: {
        // 1病种 2症状 4西医诊断
        type: {
            type: Number,
            default: 1,
        },
        list: {
            type: Array,
            default: () => [],
        },
        isEdit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        selectList() {
            return [
                { key: 1, value: "痊愈" },
                { key: 2, value: "好转(主观)" },
                { key: 3, value: "好转(客观)" },
                { key: 4, value: "好转(主观，客观)" },
                { key: 5, value: "无效(主观)" },
                { key: 6, value: "无效(客观)" },
                { key: 7, value: "无效(主观，客观)" },
                { key: 8, value: "加重" },
            ];
        },
        radioList() {
            return [
                { key: 1, value: "是" },
                { key: 0, value: "否" },
            ];
        },
        tableHeaderName() {
            return { 1: "病种评价", 2: "西医诊断评价", 4: "症状评价" }[this.type];
        },
    },
    methods: {
        findName(value, type) {
            const obj = {
                1: "radioList",
                2: "selectList",
            };
            let findObj = this[obj[type]].find((item) => item.key === value);
            return findObj ? findObj.value : "";
        },
    },
    components: {
        TextOverTooltip
    },
    watch: {
        isEdit(value) {
            if (value) {
                this.list.forEach(item => {
                    if (item.trackStatus === null) {
                        item.trackStatus = 1
                    }
                })
            }
        }
    }
};
</script>
<style lang="scss" scoped>
:deep(.vs__selected) {
    width: 18vw !important;
    padding-right: 0;
}

.switch-box {
    position: relative;
    width: 44px;
    height: 26px;

    .switch-title {
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 14px;
        color: #ffffff;

        &.switch-title-active {
            left: 5px;
            right: auto;
        }
    }

    :deep(.van-switch) {
        width: 44px;
        height: 24px;
        font-size: 14px;
        overflow: hidden;

        &.van-switch--on .van-switch__node {
            transform: translateX(22px);

            &::after {
                left: -100%;
            }
        }

        .van-switch__node {
            left: 1px;
            width: 20px;
            height: 20px;
            top: 1px;
            position: relative;

            &::after {
                content: "";
                position: absolute;
                width: 100px;
                height: 20px;
                z-index: 99;
            }
        }
    }
}

.table-form-box {
    .table-box {
        display: flex;
        padding: 15px 0;
        width: 100%;
        box-sizing: border-box;
        color: #333333;


        &:first-child {
            color: #666666;

            .tabe-item {
                color: #333333;
                font-weight: bold;

                &:first-child {
                    display: flex;
                    justify-content: flex-start;
                }
            }
        }

        &:nth-child(even) {
            background: #eff3fb;
        }

        .tabe-item {
            flex: 1;
            display: block;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            padding: 0 4px;
            flex-shrink: 0;
            width: 0;

            &:first-child {
                flex: 1.5;
                padding: 0 15px;
            }
        }

        .line-box {
            .line-title {
                margin-bottom: -7px;
            }

            .line {
                height: 3px;
                width: 100%;
                background: #0082EF;
            }
        }
    }

    .table-box-disable {
        color: #999999;
    }
}
</style>
